<template>
  <div class="h-full flex flex-col">
    <div class="dashboard-controls">
      <div
        class="container-fluid mb-4 d-flex align-items-center flex-wrap w-full justify-between"
      >
        <div class="flex flex-col">
          <h1 class="dashboard-map-title page-header-1">Map</h1>
          <h1 class="dashboard-map-date mr-auto page-header-2">
            {{ initialData?.today }}
          </h1>
        </div>
        <div class="d-flex">
          <div class="col-md scrolleable">
            <p class="mb-1 text-bold">Appointment Status</p>
            <form id="jobs-filter-form">
              <EnumFilter
                v-if="initialData"
                v-bind="initialData?.filterOptions"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
    <input
      id="tenant-subdomain"
      type="hidden"
      :value="initialData?.tenantSubdomain"
    />
    <Map v-if="initialData" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import EnumFilter from "@/Map/EnumFilter.vue";
import Map from "@/Map/Map.vue";

const initialData = ref<{
  today: string;
  filterOptions: any;
  tenantSubdomain: string;
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
